<div class="note-body" [ngClass]="this.activityCtrl?.activityState">
  <textarea
    #noteInstance
    cdkTextareaAutosize
    [cdkAutosizeMinRows]="minTextAreaRows"
    id="description"
    name="note"
    [(ngModel)]="noteText"
    ngModelOptions="{ updateOn: 'default blur', debounce: { default: 250, blur: 0 } }"
    ngTrim="false"
    class="well-textarea"
    placeholder="{{ placeholder }}"
    (focus)="setEditing(true)"
    (blur)="setEditing(false)"
    [disabled]="!this.noteEdit"
    [class.disabled]="!this.noteEdit"
    xs-auto-focus
    [setFocus]="this.needsFocus"
  >
  </textarea>
</div>
<!-- Error message place holder -->
<div *ngIf="error" class="note-error">{{ error }}</div>

<div class="note-footer" *ngIf="isFooterVisible">
  <!-- The toggle switch -->
  <app-toggle-switch-button
    [hidden]="!isPrivacySwitchVisible"
    [checked]="isPrivate"
    (change)="togglePrivacy()"
    (mousedown)="updatePrivateStatus($event)"
    captionText="{{ 'note_Private_Caption' | xsI18n }}"
  >
  </app-toggle-switch-button>
  <!-- Buttons -->
  <div class="note-footer-buttons" [hidden]="!isFooterButtonsVisible">
    <button class="xs-btn btn-outline cancel-btn" (click)="cancel()">
      <span>{{ 'xs_cancel_label_short' | xsI18n }}</span>
    </button>

    <button class="xs-btn btn-primary" (click)="save()">
      <span *ngIf="isNew">{{ 'note_Add_Caption' | xsI18n }}</span>
      <span *ngIf="!isNew">{{ 'activity_Update_Caption' | xsI18n }}</span>
    </button>
  </div>
</div>
